import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';

import rootReducer from 'modules';
import rootSaga from 'modules/sagas';

import { getIsDev } from 'utils/util';

const isDev = getIsDev();

const configureStore = ({ history }) => {
  const sagaMiddleware = createSagaMiddleware({ context: { history } });
  const middlewareEnhancer = applyMiddleware(sagaMiddleware);
  let enhancers = middlewareEnhancer;

  if (isDev) {
    const composeEnhancers = composeWithDevTools({});

    enhancers = composeEnhancers(middlewareEnhancer);
  }

  const store = createStore(rootReducer, {}, enhancers);

  sagaMiddleware.run(rootSaga);

  return store;
};

export default configureStore;
